"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateNotificationStatus = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const getNotificationList_1 = require("../../NotificationWidget/api/getNotificationList");
const useUpdateNotificationList_1 = require("./useUpdateNotificationList");
const useUpdateNotificationStatusAPI = () => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    return (body) => {
        const url = `${config.NOTIFICATION_CENTER_ENDPOINT}/user-notifications/update-status`;
        return fetch(url, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        }).catch((e) => {
            throw Error(e?.message);
        });
    };
};
const useUpdateNotificationStatus = () => {
    const queryClient = (0, frontend_infra_reactquery_1.useQueryClient)();
    const updateNotificationStatusAPI = useUpdateNotificationStatusAPI();
    const updateNotificationList = (0, useUpdateNotificationList_1.useUpdateNotificationList)();
    return (0, frontend_infra_reactquery_1.useMutation)({
        mutationKey: ['updateStatus'],
        mutationFn: updateNotificationStatusAPI,
        onSuccess: async (_, variables) => {
            console.log('Status Update Success');
            updateNotificationList(variables);
            await queryClient.invalidateQueries({ queryKey: [getNotificationList_1.NOTIFICATIONS_INFINITE_KEY] });
        },
        onError: () => {
            console.error('Status Update Failed');
        },
    });
};
exports.useUpdateNotificationStatus = useUpdateNotificationStatus;
//# sourceMappingURL=updateNotificationStatus.js.map